import { render, staticRenderFns } from "./org_name.vue?vue&type=template&id=d05aab7c&scoped=true&"
import script from "./org_name.vue?vue&type=script&lang=js&"
export * from "./org_name.vue?vue&type=script&lang=js&"
import style0 from "./org_name.vue?vue&type=style&index=0&id=d05aab7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05aab7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d05aab7c')) {
      api.createRecord('d05aab7c', component.options)
    } else {
      api.reload('d05aab7c', component.options)
    }
    module.hot.accept("./org_name.vue?vue&type=template&id=d05aab7c&scoped=true&", function () {
      api.rerender('d05aab7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/performance_manage/performace_target_report/components/org_name.vue"
export default component.exports